import { http } from '@/services/http';

export const passwordResetApi = {
  /** Requests a password-reset email. Legacy sent `email` as a query param. */
  create(email: string): Promise<unknown> {
    return http({ url: 'password_reset', method: 'post', params: { email } });
  },
  /** Finalizes password reset with the token + new password. */
  changePassword(token: string, password: string): Promise<unknown> {
    return http({ url: 'password_change', method: 'patch', params: { token, password } });
  },
};
